export function inputObjectToCamelCase<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return (obj as Date).toISOString() as any;

  if (Array.isArray(obj)) {
    return obj.map(inputObjectToCamelCase) as T;
  }

  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
    (acc as any)[camelKey] = inputObjectToCamelCase((obj as any)[key]);
    if ((acc as any)['insertedDate'] == undefined)
      (acc as any)['insertedDate'] = new Date().toISOString();
    if ((acc as any)['updatedDate'] == undefined)
      (acc as any)['updatedDate'] = new Date().toISOString();
    return acc;
  }, {} as T);
}
